/**
 * 档案管理 企业信息
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">档案管理</el-breadcrumb-item>
      <el-breadcrumb-item>企业信息</el-breadcrumb-item>
    </el-breadcrumb>
	 <el-form label-width="150px" :model="editForm" ref="editForm" style="padding-top: 20px;">
	  <el-row>
	    <el-col :span="8">
			<el-form-item label="企业名称：">
				<el-input  v-model="editForm.enterpriseName"  auto-complete="off" placeholder="请输入名称" disabled ></el-input>
			</el-form-item>
			<el-form-item label="所属地区：">
				  <el-cascader
					:options="options"
					v-model="editForm.address"
					@change="handleChange"
					:separator="' '"
					style="width: 100%;"
				  >
				  </el-cascader>
			</el-form-item>
			<el-form-item label="联系人：">
				<el-input  v-model="editForm.Contacts"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="企业类型：">
				<el-select v-model="editForm.etype" placeholder="请选择"  style="width: 100%;">
					<el-option
					  v-for="item in etype"
					  :key="item.value"
					  :label="item.label"
					  :value="item.value"
					 
					 >
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="电子邮箱：" >
				<el-input  v-model="editForm.email"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="法人代表：">
				<el-input  v-model="editForm.email"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="营业执照注册号：">
				<el-input  v-model="editForm.email"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			
			<el-form-item label="东经E：">
				<el-input  v-model="editForm.email"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="企业等级：">
				<el-select v-model="editForm.grade" placeholder="请选择">
					<el-option
					  v-for="item in grade"
					  :key="item.key"
					  :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
	    </el-col>
	    <el-col :span="8">
			<el-form-item label="企业名称简称:">
			   <el-input  v-model="editForm.Abbreviation"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="所属行业:">
			   <el-popover
				placement="right"
				title="选择行业"
				width="300"
				
				trigger="click"
				
				>
				
				<el-input slot="reference" suffix-icon="el-icon-s-data"  class='bs' v-model="editForm.industry" placeholder="点击选择行业"></el-input>
				<el-tree class="tree" :data="treeDaa" :props="defaultProps" @node-click="handleNodeClick" accordion></el-tree>
			  </el-popover>
	
			  
			</el-form-item>
			<el-form-item label="联系电话:">
			   <el-input  v-model="editForm.tel"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="企业类别:">
			   <el-input  v-model="editForm.tel"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="主要经营活动:">
			   <el-input  v-model="editForm.tel"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="注册地址:">
			   <el-input  v-model="editForm.tel"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="生产地址:">
			   <el-input  v-model="editForm.tel"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			<el-form-item label="北纬N:">
			   <el-input  v-model="editForm.tel"  auto-complete="off" placeholder="请输入名称"  ></el-input>
			</el-form-item>
			
	    </el-col>
	  </el-row>
	  <el-form-item >
	  	<el-button type="primary">保存</el-button>
	  </el-form-item>
	</el-form>
  </div>
</template>

<script>
import options from '../../assets/data/country-data.js'
import businessData from '../../assets/data/BusinessTree.js'
export default {
  data(){
	  return {
		  editForm:{
			  enterpriseName:"瑞智（九江）精密机电有限公司",
			  Abbreviation:"瑞智（九江)",
			  address:'江西省九江市',
			  Contacts:'刘工',
			  etype:'sss',
			  grade:'顶级公司',
			  industry:''
		  },
		  etype:[
			  {
				  value: '选项1',
				  label: '园区能效',
			  },
			  {
				  value: '选项2',
				  label: '园区能效2',
			  }
			],
		  grade:[
			{
				key:0,
				value:'顶级公司'
			},
			{
				key:1,
				value:'子公司'
			}
		  ],
		  selectedOptions: [],//存放默认值
          options:options,   //存放城市数据
		  treeDaa:businessData,//存放所属行业数据
		 
		  defaultProps: {
			  children: 'children',
			  label: 'text'
		  }
	 }
	 
	 
  },
  created(){
	console.log(businessData)  
  },
  methods:{
	handleChange(value) {
		
		this.editForm.address = value
		
	},
	handleNodeClick(value){
		console.log(value)
		this.editForm.industry = value.text
	}
	
  }
}
</script>

<style scoped>

.bs{
	cursor: pointer;
}
.userRole {
  width: 100%;
}
.tree{
	max-height: 500px;
	overflow-y: scroll;
	
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/archives/enterpriseInformation.vue